import { Rectangle } from '@printu/geom';
export const snapToPixel = (value, method = 'round') => Math.trunc(Math[method](value));
/**
 * Returns area inside bounds as a normalized rect
 * @param area
 * @param bounds
 * @returns
 */
export const toUniform = (area, bounds) => new Rectangle(area.x / bounds.width, area.y / bounds.height, area.width / bounds.width, area.height / bounds.height).toObject();
export const fromUniform = (bounds, uniform, snappedToPixel = false) => {
    const rect = new Rectangle(bounds.width * uniform.x, bounds.height * uniform.y, bounds.width * uniform.width, bounds.height * uniform.height)
        .translate(bounds.x, bounds.y)
        .toObject();
    if (snappedToPixel) {
        return {
            x: snapToPixel(rect.x),
            y: snapToPixel(rect.y),
            width: snapToPixel(rect.width),
            height: snapToPixel(rect.height),
        };
    }
    return rect;
};
export const scaleInAspect = (size, maxSize) => {
    const aspect = size.width / size.height;
    const maxAspect = maxSize.width / maxSize.height;
    if (aspect > maxAspect) {
        return {
            width: maxSize.width,
            height: maxSize.width / aspect,
        };
    }
    return {
        width: maxSize.height * aspect,
        height: maxSize.height,
    };
};
